import { jsx as e } from "react/jsx-runtime";
import { normaliseResponsiveProp as u } from "../../../utils/responsiveProps.js";
import d from "../Box/Box.js";
import "styled-components";
import { ColumnsContext as x } from "./ColumnsContext.js";
import { resolveCollapsibleProps as b } from "./utils.js";
function y({
  children: t,
  collapseBelow: i,
  reverseOnCollapse: o,
  alignY: l,
  alignX: r,
  space: n = "none"
}) {
  const {
    flexDirection: p,
    collapseOnMobile: m,
    collapseOnTablet: s
  } = b({
    collapseBelow: i,
    reverseOnCollapse: o
  }), [a, c, f] = u(
    n
  );
  return /* @__PURE__ */ e(
    d,
    {
      display: "flex",
      flexDirection: p,
      alignItems: l,
      justifyContent: r,
      width: "100%",
      children: /* @__PURE__ */ e(
        x.Provider,
        {
          value: {
            collapseOnMobile: m,
            collapseOnTablet: s,
            mobileSpace: a,
            tabletSpace: c,
            desktopSpace: f,
            reverseOnCollapse: o
          },
          children: t
        }
      )
    }
  );
}
export {
  y as default
};
